module.exports = [
  ...require('./absorbingTattoo'),
  ...require('./allPurposeTool'),
  ...require('./amuletOfTheDevout'),
  ...require('./arcaneGrimoire'),
  ...require('./barrierTattoo'),
  ...require('./bloodwellVial'),
]
